import Splide from '@splidejs/splide';
import trapFocus from '../focus-trap';

window.addEventListener('DOMContentLoaded', () => {
  const imageSliderModals = document.querySelectorAll('.js-imageSliderModal');

  imageSliderModals.forEach(modalWrapper => {
    const modal = modalWrapper.querySelector('.js-imageSliderModal-modal');
    const openButtonsArray = modalWrapper.querySelectorAll('.js-imageSliderModal-open');
    const closeButton = modalWrapper.querySelector('.js-imageSliderModal-close');
    const slider = modalWrapper.querySelector('.js-imageSliderModal-slider');

    openButtonsArray.forEach((openButton, index) => {
      openButton.addEventListener('click', event => {
        const slideIndex = event.target.dataset.slideIndex ? 0 : index;
        modal.showModal();
        const splide = new Splide(slider, {
          type: 'fade',
          rewind: true,
          speed: 500,
          start: slideIndex,
          pagination: false,
        });
        splide.mount();
        trapFocus(modal);
      });
    });

    closeButton.addEventListener('click', () => {
      modal.close();
    });
  });
});